import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_80: DocMigration = {
  maxSchemaVersion: "0.0.80",
  description: "Clean up duplicate room layout data",
  apply(json: any) {
    // Previous incomplete migrations might have left room layout data under room data.
    for (const roomId in json.rooms) {
      const room = json.rooms[roomId];
      if (room.layout) {
        // The data should be under roomLayouts, but the layout might have been changed
        // after the incomplete migration, so we can't check that in a robust way.
        delete room.layout;
      }
    }
    return json;
  },
};

export default migration_0_0_80;
